import { types } from './actions';

const initialState = {
  authInfo: undefined,
  defaultDashboardId: undefined,
  selectedDashboardId: undefined,
  selectedQueryId: undefined,
  isInitializing: true,
  isInitializerExplore: true,
  isLoadingDashboard: false,
  dashboards: [],
  timezone: undefined,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.ANALYTICS_AUTHENTICATE_SUCCESS:
      return {
        ...state,
        authInfo: payload.authInfo,
      };
    case types.ANALYTICS_INIT_REQUEST:
      return {
        ...state,
        isInitializing: true,
      };
    case types.ANALYTICS_INIT_SUCCESS:
      return {
        ...state,
        isInitializing: false,
        dashboards: payload.dashboards,
        selectedDashboardId: payload.selectedDashboardId,
        defaultDashboardId: payload.defaultDashboardId,
        timezone: payload.timezone,
      };
    case types.ANALYTICS_INIT_ERROR:
      return {
        ...state,
        isInitializing: false,
      };
    case types.ADD_DASHBOARD: {
      return {
        ...state,
        dashboards: [...state.dashboards, payload.dashboard],
        selectedDashboardId: payload.dashboard.id,
      };
    }
    case types.REMOVE_DASHBOARD: {
      return {
        ...state,
        selectedDashboardId: state.defaultDashboardId,
        dashboards: state.dashboards.filter(
          (dashboard) => dashboard.id != payload.dashboardId,
        ),
      };
    }
    case types.UPDATE_DASHBOARD: {
      return {
        ...state,
        dashboards: state.dashboards.map((dashboard) =>
          dashboard.id === payload.dashboard.id ? payload.dashboard : dashboard,
        ),
      };
    }
    case types.SET_SELECTED_DASHBOARD:
      return {
        ...state,
        selectedDashboardId: payload.dashboardId,
      };
    case types.INIT_EXPLORE_ERROR:
      return {
        ...state,
        isInitializerExplore: false,
      };
    case types.INIT_EXPLORE_REQUEST:
      return {
        ...state,
        selectedQueryId: undefined,
        isInitializerExplore: true,
      };
    case types.INIT_EXPLORE_SUCCESS:
      return {
        ...state,
        timezone: payload.timezone,
        selectedQueryId: payload.queryId,
        isInitializerExplore: false,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.analytics;

export const getDashboards = (state) => getScope(state).dashboards;

export const getIsLoadingDashboard = (state) =>
  getScope(state).isLoadingDashboard;

export const getIsInitializing = (state) => getScope(state).isInitializing;

export const getIsInitializingExplore = (state) =>
  getScope(state).isInitializerExplore;

export const getSelectedQueryId = (state) => getScope(state).selectedQueryId;

export const getSelectedDashboardId = (state) =>
  getScope(state).selectedDashboardId;

export const getDefaultDashboardId = (state) =>
  getScope(state).defaultDashboardId;

export const getTimezone = (state) => getScope(state).timezone;

export const getAuthInfo = (state) => getScope(state).authInfo;

export default reducer;
